<template>
    <div class="kt-portlet__head">
        <form class="isprint-filter" autocomplete="off">
            <div class="row">
                <div class="form-group mt-1 mr-2 ml-4 float-left">
                    <label>Nome</label><br />
                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                        placeholder="Nome" type="text" style="width:150px"
                        v-model="search.NOME.VALUE">
                </div>
                <div class="form-group mt-1 mr-2 float-left">
                    <label>Cognome</label><br />
                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                        placeholder="Cognome" type="text" style="width:150px" v-model="search.COGNOME.VALUE">
                </div>
                <div class="form-group mt-1 mr-2 float-left">
                    <label>Codice Fiscale</label><br />
                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                        placeholder="Codice Fiscale" type="text" style="width:150px"
                        v-model="search.CODICE_FISCALE.VALUE">
                </div>
            </div>
            <button class="btn btn-success float-right btn-sm my-2 my-sm-3" v-on:click="creaAmministratore()"
                style="margin-top:26px"><i class="fal fa-plus"></i> Crea Amministratore</button>
        </form>
    </div>
    <div class="isprint-grid-container" style="margin-top: 20px;">
        <table class="isprint-grid shadow">
            <thead class="isprint-grid-thead">
                <tr style="left: 0px;background:#7b7158;color:#fff">
                    <th style="width:10%"><span>Nome</span></th>
                    <th style="width:10%"><span>Cognome</span></th>
                    <th style="width:20%"><span>Codice Fiscale</span></th>
                    <th style="width:20%"><span>Indirizzo</span></th>
                    <th style="width:20%"><span>Contatti</span></th>
                    <th style="width:10%"><span>Flag Elimina</span></th>
                    <th style="width:10%"><span>Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-for="amministratore in paginatedList.arr" v-bind:key="amministratore.ID_AMMINISTRATORE">
                    <td style="width:10%">
                      <span><strong>{{amministratore.NOME}}</strong></span>
                    </td>
                    <td style="width:10%">
                        <span><strong>{{amministratore.COGNOME }}</strong></span>
                    </td>
                    <td style="width:20%">
                        <i class="fad fa-address-card fa-2x mr-2" aria-hidden="true"></i>
                        <strong>{{ amministratore.CODICE_FISCALE}}</strong>
                    </td>
                    <td style="width:20%">
                        <strong>{{ amministratore.INDIRIZZO}}</strong>
                    </td>
                    <td style="width:20%">
                        <span><i class="fad fa-phone-alt"></i> {{ amministratore.TELEFONO }}</span><br />
                        <a :href="'mailto:' + amministratore.EMAIL"><span><i class="fad fa-envelope"></i> {{ amministratore.EMAIL }}</span></a>
                    </td>
                    <td style="width:10%;">
                        <ISwitch @toggle="updateLavorazione(amministratore)" :size="'sm'" v-model="amministratore.FLG_LAVORATO" style="margin-top:6px"></ISwitch>
                    </td>
                    <td style="width:10%; ">
                        <div class="btn-group float-right" role="group" aria-label="Basic example">
                            <button data-toggle="tooltip" data-placement="top" title="Modifica amministratore"
                                class="btn btn-warning btn-sm float-right" v-on:click="modificaAmministratore(amministratore)"><i
                                    class="fal fa-pencil"></i></button>
                            <button v-show="amministratore.FLG_LAVORATO == 1" data-toggle="tooltip" data-placement="top" title="Elimina amministratore"
                                class="btn btn-danger btn-sm float-right" v-on:click="deleteAmministratore(amministratore)"><i
                                    class="fal fa-trash-alt"></i></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count"
            :numpagine="search.PAGINATION.LENGTH"></Pagine>
    </div>
    <div class="modal fade" id="popUpAmministratore" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog" style="min-width:800px;">
            <div class="modal-content">
                <div class="modal-header modal-header" style="background:#7b7158">
                    <h4 style="color:#fff" class="modal-title"><i class="fal fa-user-crown fa-fw"></i> Amministratore</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group col-md-12">
                        <PersonaFisica v-model="amministratoreSelezionato.personaFisica"></PersonaFisica>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaAmministratore()"><i class="fa fa-check"></i>
                        Salva</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagine from '@/components/utils/Pagine.vue'
import PersonaFisica from '@/components/common/PersonaFisica.vue'
import ISwitch from '../components/utils/ISwitch.vue';


export default {
    name: "Amministratori",
    components: {
        Pagine,
        PersonaFisica,
        ISwitch,
    },
    data: function () {
        return {
            filters: global.filters,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                NOME: { TYPE: 'TEXT', VALUE: '' },
                COGNOME: { TYPE: 'TEXT', VALUE: '' },
                CODICE_FISCALE: { TYPE: 'TEXT', VALUE: '' },
            },
            arrayAmministratori: new Array(),
            amministratoreSelezionato: { personaFisica: {}}
        }
    },
    methods: {
        getAmministratori: function () {
            this.arrayAmministratori = new Array();
            global.utils.get('/es/amministratori', {}, (response) => {
                this.arrayAmministratori = response.data;
                this.$forceUpdate();
            });
        },
        getAmministratore: function (idAmministratore) {
            global.utils.get('/es/amministratore', {ID_AMMINISTRATORE : idAmministratore}, (response) => {
                this.amministratoreSelezionato = utils.clone(response.data)
            });
        },
        creaAmministratore: function () {
            this.amministratoreSelezionato = { ID_PERSONA_FISICA: 0 ,personaFisica: {}}
            var modal = utils.openModal('popUpAmministratore');
        },
        modificaAmministratore: function (amministratore) {
             this.amministratoreSelezionato = this.getAmministratore(amministratore.ID_AMMINISTRATORE);
            var modal = utils.openModal('popUpAmministratore');
        },
        deleteAmministratore: function (amministratore) {
            utils.alert.confirm("Sei sicuro di voler procedere con l'eliminazione dell'amministratore? Questa azione cancellerà ogni collegamento con i clienti associati", () => {
                global.utils.delete('/es/amministratore', { ID_AMMINISTRATORE: amministratore.ID_AMMINISTRATORE }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getAmministratori();
                    }
                });
            }, this.$root);
        },
        salvaAmministratore: function () {
            if(this.amministratoreSelezionato.personaFisica.NOME && this.amministratoreSelezionato.personaFisica.COGNOME){
                if (this.amministratoreSelezionato.ID_AMMINISTRATORE > 0) {
                    global.utils.put('/es/amministratore', this.amministratoreSelezionato, (response) => {
                        if (response.esito == 0) {
                            this.getAmministratori();
                            var modal = utils.closeModal('popUpAmministratore');
                            utils.alert.success(response.messaggio);
                        }
                    });
                } else {
                    global.utils.post('/es/amministratore', this.amministratoreSelezionato, (response) => {
                        if (response.esito == 0) {
                            this.getAmministratori();
                            var modal = utils.closeModal('popUpAmministratore');
                            utils.alert.success(response.messaggio);
                        }
                    });
                }
            }else{
                utils.alert.warning("È necessario specificare il NOME e il COGNOME dell'Amministratore")
            }
        },
        updateLavorazione: function (amministratore) {
            setTimeout(() => {
                utils.ajax('es/amministratore/update', amministratore, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        var modal = $('#popUpAmministratore');
                        modal.modal('hide');
                    }
                });
            }, 250);
        },
    },
    computed: {
        paginatedList() {
            var arr = utils.inGrid(this.arrayAmministratori, this.search);
            return arr;
        },
    },
    created: function () {
        this.getAmministratori();
    },
}
</script>
